document.addEventListener("DOMContentLoaded", function () {
    try {
        ts_lg_ivc_loadDefaultVariant();
        ts_lg_ivc_setClassObserver();
    } catch (error) {
        console.log("ERROR:", error);
    }
});

function ts_lg_ivc_loadDefaultVariant() {
    const ts_lg_ivc_defaultVariant = document.querySelector('.variant__input--color-swatch:checked');
    if (ts_lg_ivc_defaultVariant) {
        ts_lg_ivc_defaultVariant.checked = false;
        ts_lg_ivc_defaultVariant.click();
    }
}

function ts_lg_ivc_getSelectedImageSrc() {
    const selectedImage = document.querySelector(".product__main-photos .is-selected img");
    if (selectedImage) {
        return ts_lg_ivc_cleanString(selectedImage.getAttribute("src"));
    }
}

function ts_lg_ivc_cleanString(inputString, removeString = "?v=") {
    const stringPosition = inputString.indexOf(removeString);
    let cleanedString = "";
    if (stringPosition !== -1) {
        cleanedString = inputString.substring(0, stringPosition);
        cleanedString = cleanedString.replace("//lieblingsgarn.de/cdn/shop/", "");
    } else {
        cleanedString = inputString.replace("//lieblingsgarn.de/cdn/shop/", "");
    }

    return cleanedString;
}

function ts_lg_ivc_loadVariant(selectedImageSrc) {
    variants = document.querySelectorAll(".ts-lg-variant-dropdown-image");
    variants.forEach(function (element) {
        let srcAttribute = element.getAttribute("src");
        if (srcAttribute.includes(selectedImageSrc)) {
            element.click();
        }
    });
}

function ts_lg_ivc_setClassObserver() {
    const elementsToObserve = document.querySelectorAll(".product__main-photos .product-main-slide");
    const mutationCallback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
                if (mutation.target.classList.contains("is-selected")) {
                    try {
                        ts_lg_ivc_loadVariant(ts_lg_ivc_getSelectedImageSrc());
                    } catch (error) {
                        console.log("ERROR:", error);                        
                    }
                }
            }
        }
    };
    const observers = [];
    elementsToObserve.forEach((element) => {
        const observer = new MutationObserver(mutationCallback);
        const observerConfig = { attributes: true };
        observer.observe(element, observerConfig);
        observers.push(observer);
    });
}